export default __webpack_public_path__ + "static/media/screenshoot.e71c779e.png";